import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    barIdentifier: String,
    resourceType: String,
    resourceId: String,
    deselectOnDisconnect: Boolean,
  };

  connect() {
    window.addEventListener('load', this.#initializeSelection.bind(this));
  }

  disconnect() {
    this.deselectOnDisconnectValue && this.element.checked && this.#dispatch('remove');
  }

  toggle() {
    this.element.checked ? this.#dispatch('add') : this.#dispatch('remove');
  }

  #initializeSelection() {
    this.element.checked && this.#dispatch('add');
  }

  #dispatch(action) {
    const eventName = `batch-actions:${this.barIdentifierValue}:${action}`;
    const actionEvent = new CustomEvent(eventName, this.#eventData);

    document.dispatchEvent(actionEvent);
  }

  get #eventData() {
    const type = this.resourceTypeValue;
    const id = this.resourceIdValue;
    const element = { resource_type: type, resource_id: id, element: this.element };

    return { detail: { element } };
  }
}
